import { IconProps } from '../../types/icon';
import { Svg } from '../style';

const Document = ({ width = 24, height = 18, fill = '#119B94', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.30629 18C1.67206 18 1.12912 17.7797 0.677472 17.3391C0.225824 16.8984 0 16.3687 0 15.75V2.25C0 1.63125 0.225824 1.10156 0.677472 0.660937C1.12912 0.220312 1.67206 0 2.30629 0H8.2738C8.58131 0 8.8744 0.05625 9.15307 0.16875C9.43175 0.28125 9.67679 0.440625 9.8882 0.646875L11.5314 2.25H21.9097C22.2364 2.25 22.5103 2.35781 22.7313 2.57344C22.9524 2.78906 23.0629 3.05625 23.0629 3.375C23.0629 3.69375 22.9524 3.96094 22.7313 4.17656C22.5103 4.39219 22.2364 4.5 21.9097 4.5H10.5801L8.2738 2.25H2.30629V15.75L4.58374 8.35312C4.7375 7.86562 5.02098 7.47656 5.43419 7.18594C5.8474 6.89531 6.30385 6.75 6.80354 6.75H21.6791C22.4671 6.75 23.0869 7.05469 23.5385 7.66406C23.9902 8.27344 24.1103 8.93437 23.8989 9.64687L21.8232 16.3969C21.6695 16.8844 21.386 17.2734 20.9728 17.5641C20.5596 17.8547 20.1031 18 19.6034 18H2.30629ZM4.72789 15.75H19.6034L21.6791 9H6.80354L4.72789 15.75Z"
        fill={fill}
      />
    </Svg>
  );
};

export default Document;
